import { PostEditCTA, PostEditCTAProps } from "~/components/PostEditCTA";
import { Checkbox } from "~/ui-library";

export type LandingPagePostEditCTAProps = PostEditCTAProps & {
  isChecked: boolean;
  setIsChecked: (val: boolean) => void;
};

export const LandingPagePostEditCTA: React.FC<LandingPagePostEditCTAProps> = ({
  isChecked,
  setIsChecked,
  ...props
}) => (
  <PostEditCTA
    {...props}
    startContent={
      <Checkbox
        checked={isChecked}
        onChange={(e) => setIsChecked(e.target.checked)}
        label="Show block skeleton"
      />
    }
  />
);
